var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGrayArrow = function SvgGrayArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9308 3.48338C25.852 1.3396 22.8065 0 18.9445 0H6.88892C5.93777 0 5.1667 0.771065 5.1667 1.72222C5.1667 2.67338 5.93777 3.44444 6.88892 3.44444H18.9445C21.9714 3.44444 24.0924 4.4729 25.4581 5.88121C26.8433 7.30975 27.5556 9.23614 27.5556 11.1944C27.5556 13.1527 26.8433 15.0791 25.4581 16.5077C24.0924 17.916 21.9714 18.9444 18.9445 18.9444H5.88005L11.5512 13.2734C12.2237 12.6008 12.2237 11.5103 11.5512 10.8378C10.8786 10.1652 9.78815 10.1652 9.11558 10.8378L0.504429 19.4489C0.18145 19.7718 0 20.2099 0 20.6667C0 21.1234 0.18145 21.5615 0.504429 21.8845L9.11558 30.4956C9.78815 31.1681 10.8786 31.1681 11.5512 30.4956C12.2237 29.823 12.2237 28.7325 11.5512 28.06L5.88005 22.3889H18.9445C22.8064 22.3889 25.852 21.0493 27.9308 18.9055C29.99 16.782 31 13.9723 31 11.1944C31 8.41664 29.99 5.60692 27.9308 3.48338Z",
    fill: "#222222",
    fillOpacity: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GrayArrow.ac01b8d4.svg";
export { ForwardRef as ReactComponent };